import { render, staticRenderFns } from "./complaintManageDetail.vue?vue&type=template&id=55161f58&scoped=true"
import script from "./complaintManageDetail.vue?vue&type=script&lang=js"
export * from "./complaintManageDetail.vue?vue&type=script&lang=js"
import style0 from "./complaintManageDetail.vue?vue&type=style&index=0&id=55161f58&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55161f58",
  null
  
)

export default component.exports